export const RNMapView = null;
export const Marker = null;
export const PROVIDER_GOOGLE = undefined;
